import { EntranceExamStateType } from '../../scenes/Students/HOC/withEntranceExam/types';

export const ExamInitialState: EntranceExamStateType = {
    quizzes: {} as any
};
